import { Button, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { customerDetailsPath } from './routes';
import { serverSortProps } from '../utilities/helper';
import TimeAgo from '../components/TimeAgo';

const { Text } = Typography;

// First Name, Last Name and Created At are sorted on the server (see Customers component)

export const customerTable = (offset, sort = null) => [
    {
        title: 'Sr. No',
        key: 'serial_no',
        className: 'col-index',
        width: 72,
        responsive: ['sm'],
        render: (item, record, index) => <Text>{offset + index + 1}</Text>
    },
    {
        title: "First Name",
        key: "first_name",
        dataIndex: "first_name",
        ...serverSortProps(sort, 'first_name'),
    },
    {
        title: "Last Name",
        key: "last_name",
        dataIndex: "last_name",
        ...serverSortProps(sort, 'last_name'),
    },
    {
        title: "E-mail address",
        key: "email_address",
        dataIndex: "email_address",
        //    render: (item) => <Text>{item ? `$${item}` : '--'}</Text>,
    },
    {
        title: "Current Balance",
        key: "current_balance",
        dataIndex: "current_balance",
        align: 'right',
        className: 'col-num',
        responsive: ['md'],
        render: (item) => <Text>{item ? `$${item}` : '--'}</Text>,
    },
    {
        title: "Created At",
        key: "created_at",
        className: 'col-date',
        ...serverSortProps(sort, 'created_at'),
        render: (item) => <TimeAgo value={item && item.created_at} />,
    },
    {
        title: 'Action',
        key: 'action',
        align: 'right',
        className: 'col-actions',
        fixed: 'right',
        render: (item, record) => item
        ? (
            <Link to={customerDetailsPath(record.uuid)}>
                <Button type='primary' icon={<ArrowRightOutlined />}>
                    Details
                </Button>
            </Link>
        )
        : '--'
    },
];
